<template>
    <rkm-overlay>
        <rkm-layout-body title=" Avaliaçăo de Elegibilidade e admissăo ">
            <template v-slot:actions>
                <rkm-button
                    @click="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>

                <rkm-button
                    @click="$refs.Form.save()"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>

            <rkm-layout-content>
                <Form
                    :id="id"
                    :edit="edit"
                    @save="handleSave"
                    ref="Form"
                />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import Form from "@/components/atencao-basica/avaliacao/Form";

import { mapActions } from 'vuex';

import { repository, error, object, data } from '@/mixins'

export default {
    components: { Form },
    created() {
        this.setShowExitFormConfirmation()
    },
    data: () => ({
        cadastro: false,
    }),
    methods: {
        ...mapActions([
            'setShowExitFormConfirmation',
            'unsetShowExitFormConfirmation',
            'setLoading',
            'unsetLoading'
        ]),
        handleExit() {
            this.$router.push({ name: 'atencao-basica-avaliacao' })
        },
        handleSave() {
            this.unsetShowExitFormConfirmation()
            this.handleExit()
        },
    },
    mixins: [repository, error, object, data],
    props: {
        id: { type: Number, required: true },
        edit: { type: Boolean, default: false }
    }
}
</script>